import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import { useIntl } from "react-intl";
import useSWR from "swr";

import { MultiSelect, Tipografia } from "../../../../_common";
import { TIPO_CONTATO } from "./constantes";

const styles = {
  multiSelectWrapper: {
    marginLeft: 18,
    width: 350,
  },
  spanError: { color: "#f44336", fontSize: "12px" },
  labelWrapper: {
    marginLeft: 8,
    marginTop: 8,
  },
};

function SeletorContatos({ label, lead, setContatosId, isContatosValid, setIsContatosValid, tipoContato, classes }) {
  const intl = useIntl();
  const [selectedIds, setSelectedIds] = useState([]);
  const { data: contatosAtualizados } = useSWR(lead ? `/api/pipeline/lead/contatos?id=${lead.id}` : null);
  const isChecked = (contatoId, selectedIdsChecked) => selectedIdsChecked.includes(contatoId);

  const getPrimaryInfo = contato => {
    if (tipoContato === TIPO_CONTATO.EMAIL) {
      return contato.emails?.find(email => email.principal)?.endereco;
    }
    if (tipoContato === TIPO_CONTATO.TELEFONE) {
      return contato.telefones?.find(tel => tel.principal)?.numero;
    }
    return null;
  };

  const hasValidInfo = contato => {
    if (tipoContato === TIPO_CONTATO.EMAIL) {
      return Array.isArray(contato.emails) && contato.emails.some(email => email.endereco);
    }
    if (tipoContato === TIPO_CONTATO.TELEFONE) {
      return Array.isArray(contato.telefones) && contato.telefones.some(tel => tel.numero);
    }
    return false;
  };

  const initialItems = (contatosAtualizados || []).filter(hasValidInfo).map(contato => ({
    ...contato,
    descricao: `${contato.nome} [${lead.nome}]`,
    secondaryText: getPrimaryInfo(contato),
    checked: isChecked(contato.id, selectedIds),
  }));

  const handleOnChange = (event, items) => {
    const selected = items.filter(item => item.checked).map(item => item.id);
    setSelectedIds(selected);
    setContatosId(selected);
    setIsContatosValid(selected.length > 0);
  };

  useEffect(
    () => {
      if (contatosAtualizados) {
        const selected = contatosAtualizados
          .filter(hasValidInfo)
          .filter(contato => {
            if (lead.contatos?.length > 0) {
              const infoPrincipal = getPrimaryInfo(contato);
              return lead.contatos.some(
                leadContato =>
                  tipoContato === TIPO_CONTATO.EMAIL
                    ? leadContato.email === infoPrincipal
                    : leadContato.telefone === infoPrincipal
              );
            }
            return contato.principal;
          })
          .map(contato => contato.id);

        setSelectedIds(selected);
        setContatosId(selected);
        setIsContatosValid(selected.length > 0);
      }
    },
    [contatosAtualizados, lead.contatos, tipoContato]
  );

  return contatosAtualizados?.length ? (
    <div className={classes.multiSelectWrapper}>
      <MultiSelect
        floatingLabelText={label}
        initialItems={initialItems}
        onChange={handleOnChange}
        width="100%"
        labelNoItems={
          tipoContato === TIPO_CONTATO.EMAIL
            ? intl.formatMessage({ defaultMessage: "Esse lead não possui contato com e-mail" })
            : intl.formatMessage({
                defaultMessage: "Esse lead não possui contato com telefone",
              })
        }
        isSelectContatos
      />
      {!isContatosValid && (
        <span className={classes.spanError}>{intl.formatMessage({ defaultMessage: "Campo Obrigatório" })}</span>
      )}
    </div>
  ) : (
    <div className={classes.labelWrapper}>
      <Tipografia tipo="textoSidebar" italico>
        {intl.formatMessage({ defaultMessage: "Esse lead não tem contatos" })}
      </Tipografia>
    </div>
  );
}

SeletorContatos.propTypes = {
  label: PropTypes.string,
  lead: PropTypes.object,
  setContatosId: PropTypes.func,
  setIsContatosValid: PropTypes.func,
  isContatosValid: PropTypes.bool,
  tipoContato: PropTypes.string,
};

export default withStyles(styles)(SeletorContatos);
